import { atomWithStorage } from 'jotai/utils';

import { atom } from 'jotai';
import { WidgetType } from '../../modules/dashboard/types';
import { HelpHeadingText, HelpSubText } from '../../modules/dashboard/components/organisms/grid-layout/layouts/layoutUtils/helpContent';

export const doughnutChartColours = [
  ' #124E57',
  ' #F69521',
  ' #F15A22',
  ' #3D7369',
  ' #103240',
  ' #15808D',
  ' #A5242F'
];

export const otherSegmentColour = ' #A3A580';
export const otherInvestmentName = 'Other';

export const isEditingPersonalDetailsAtom = atomWithStorage<boolean>(
  'isEditingPersonalDetails',
  false
);

export const listWidgetDataAtom = atomWithStorage<string[]>('listWidgetData', [
  'Item 1',
  'Item 2',
  'Item 3'
]);

export interface Beneficiary {
  firstName: string;
  surname: string;
  investmentBreakdown: InvestmentBreakdown[];
}

export interface InvestmentBreakdown {
  number: string;
  name: string;
  roles: string[];
}

export const hiddenWidgetsAtom = atomWithStorage<WidgetType[]>('hideWidgetContent', []);

export interface Beneficiary {
  firstName: string;
  surname: string;
  investmentBreakdown: InvestmentBreakdown[];
}

export interface InvestmentBreakdown {
  number: string;
  name: string;
  roles: string[];
}

export const dashboardType = atom<string | undefined>('intermediary');

export const clientTypeAtom = atom<string | undefined>(undefined);

export const helpTextAtom = atom((get) => {
  const clientType = get(clientTypeAtom);
  return {
    heading:
      clientType === 'Natural'
        ? HelpHeadingText.PersonalDetailsNatural
        : HelpHeadingText.PersonalDetailsLegal,
    subText:
      clientType === 'Natural'
        ? HelpSubText.PersonalDetailsNatural
        : HelpSubText.PersonalDetailsLegal
  };
});
